const MOEDA = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const INTEIRO = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });
const PERCENTUAL = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const COMPACTO = new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 } as any);
const DECIMAIS: { [casas: number]: Intl.NumberFormat } = {};
const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

function decimal(casas: number): Intl.NumberFormat {
  if (!DECIMAIS[casas]) {
    DECIMAIS[casas] = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
  }
  return DECIMAIS[casas];
}

export function formatarValor(valor: any, tipo: string, formato?: string, casas?: number): string {
  if (valor === null || valor === undefined || valor === '') {
    return '';
  }
  const alvo = formato || tipo;
  switch (alvo) {
    case 'moeda':
      return MOEDA.format(Number(valor));
    case 'decimal':
      return decimal(casas ?? 2).format(Number(valor));
    case 'inteiro':
      return INTEIRO.format(Number(valor));
    case 'percentual':
      return PERCENTUAL.format(Number(valor)) + '%';
    case 'data':
      return data(String(valor));
    case 'dataHora': {
      const texto = String(valor);
      return texto.length > 10 ? data(texto) + ' ' + texto.substring(11, 16) : data(texto);
    }
    case 'booleano':
      return valor === true || valor === 'true' ? 'Sim' : 'Não';
    case 'cpfCnpj':
      return mascarar(String(valor), { 11: '000.000.000-00', 14: '00.000.000/0000-00' });
    case 'cep':
      return mascarar(String(valor), { 8: '00000-000' });
    case 'telefone':
      return mascarar(String(valor), { 10: '(00) 0000-0000', 11: '(00) 00000-0000' });
    default:
      return String(valor);
  }
}

export function casasDecimais(valores: any[]): number {
  let casas = 2;
  for (const v of valores) {
    if (v === null || v === undefined || v === '') {
      continue;
    }
    const texto = String(v);
    const ponto = texto.indexOf('.');
    if (ponto >= 0) {
      const frac = texto.substring(ponto + 1).replace(/0+$/, '').length;
      casas = Math.max(casas, Math.min(frac, 4));
    }
  }
  return casas;
}

export function compacto(valor: number, formato: string): string {
  if (formato === 'moeda') {
    return 'R$ ' + COMPACTO.format(valor);
  }
  if (formato === 'percentual') {
    return PERCENTUAL.format(valor) + '%';
  }
  return COMPACTO.format(valor);
}

export function rotuloData(valor: any, agrupar: string): string {
  if (!valor) {
    return '(vazio)';
  }
  const [ano, mes, dia] = String(valor).substring(0, 10).split('-');
  switch (agrupar) {
    case 'ano':
      return ano;
    case 'mes':
      return `${MESES[Number(mes) - 1]}/${ano.substring(2)}`;
    case 'semana':
      return `sem. ${dia}/${mes}`;
    default:
      return `${dia}/${mes}`;
  }
}

export function numerico(tipo: string): boolean {
  return ['inteiro', 'decimal', 'moeda', 'percentual'].includes(tipo);
}

function mascarar(texto: string, mascaras: { [digitos: number]: string }): string {
  const digitos = texto.replace(/\D/g, '');
  const mascara = mascaras[digitos.length];
  if (!mascara) {
    return texto;
  }
  let i = 0;
  return mascara.replace(/0/g, () => digitos[i++]);
}

function data(texto: string): string {
  const [ano, mes, dia] = texto.substring(0, 10).split('-');
  return dia && mes && ano ? `${dia}/${mes}/${ano}` : texto;
}
